/**
 * @generated SignedSource<<ed8ce8c21c7eea858e45ac4efcf774dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Transfer_metadata$data = {
  readonly receivedAssetQuantities: ReadonlyArray<{
    readonly asset: {
      readonly " $fragmentSpreads": FragmentRefs<"StackedAssetMedia_assets">;
    };
  }>;
  readonly recipient: {
    readonly address: string;
  } | null | undefined;
  readonly sentAssetQuantities: ReadonlyArray<{
    readonly asset: {
      readonly " $fragmentSpreads": FragmentRefs<"StackedAssetMedia_assets">;
    };
  }>;
  readonly " $fragmentType": "Transfer_metadata";
};
export type Transfer_metadata$key = {
  readonly " $data"?: Transfer_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"Transfer_metadata">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AssetType",
    "kind": "LinkedField",
    "name": "asset",
    "plural": false,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "StackedAssetMedia_assets"
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Transfer_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetQuantityType",
      "kind": "LinkedField",
      "name": "sentAssetQuantities",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetQuantityType",
      "kind": "LinkedField",
      "name": "receivedAssetQuantities",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountType",
      "kind": "LinkedField",
      "name": "recipient",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TransactionMetadataType",
  "abstractKey": null
};
})();

(node as any).hash = "1d144c6de8d18ec87ac6c0f6180ef52b";

export default node;
